export default __webpack_public_path__ + "static/media/webinars-1.8aedfe4c.jpg";